const getQueryParams = (targetParameter: string, queryString = '') => {
  if (queryString === '' && window !== undefined) {
    queryString = window.location.search;
  }

  if (queryString.startsWith('?')) {
    queryString = queryString.slice(1);
  }
  const params = new URLSearchParams(queryString);
  const queryParameter = params.get(targetParameter);

  return queryParameter ? queryParameter : null;
};

export default getQueryParams;
